export default "__VITE_ASSET__Xi7ybb5T__"